
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_sdha6_19gkg_9",
  "handle-size-normal": "awsui_handle-size-normal_sdha6_19gkg_17",
  "handle-size-small": "awsui_handle-size-small_sdha6_19gkg_21",
  "handle-drag-indicator": "awsui_handle-drag-indicator_sdha6_19gkg_24",
  "handle-disabled": "awsui_handle-disabled_sdha6_19gkg_24",
  "active": "awsui_active_sdha6_19gkg_27",
  "handle-resize-area": "awsui_handle-resize-area_sdha6_19gkg_30",
  "handle-resize-horizontal": "awsui_handle-resize-horizontal_sdha6_19gkg_48",
  "handle-resize-vertical": "awsui_handle-resize-vertical_sdha6_19gkg_51",
  "hide-focus": "awsui_hide-focus_sdha6_19gkg_61",
  "resize-icon": "awsui_resize-icon_sdha6_19gkg_84",
  "resize-icon-vertical": "awsui_resize-icon-vertical_sdha6_19gkg_90",
  "resize-icon-horizontal": "awsui_resize-icon-horizontal_sdha6_19gkg_94",
  "prevent-pointer": "awsui_prevent-pointer_sdha6_19gkg_98"
};
  